import { ActionAfterViewObserver } from '@cian/action-after-viewed-component';
import { IconFinanceMortgage16 } from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';

import * as styles from './MortgageWidget.css';
import { TMortgageBannerVerticalName, trackMortgageWidgetAnchorClick, trackMortgageWidgetAnchorShow } from './tracking';
import { calcPayment, formatNumber } from '../../../packages/mortgage-calculator/shared/helpers';
import { scrollToElement } from '../../utils/navigation';
import { buildMortgageBannerUnderPriceIpotekaUrl } from '../../utils/tracking/mortgageUnderPriceCianBanner';

export interface IMortgageMortgageWidgetProps {
  mortgageWidgetMarkup?: string;
  price: number;
  rate: number;
  verticalName: TMortgageBannerVerticalName;
}

export const MortgageWidget = (props: IMortgageMortgageWidgetProps) => {
  const { mortgageWidgetMarkup, price, rate, verticalName } = props;
  const minPayment = calcPayment(price, price * 0.2, rate, 20 * 12);
  const redirectPath = buildMortgageBannerUnderPriceIpotekaUrl(verticalName);

  if (!mortgageWidgetMarkup) {
    const handleAnchorClick = (e: React.MouseEvent) => {
      e.preventDefault();

      const underMapElement = document.getElementById('servicePlaceUnderMap');

      if (underMapElement) {
        scrollToElement(underMapElement);
      } else {
        window.open(redirectPath, '_blank');
      }

      trackMortgageWidgetAnchorClick(verticalName);
    };

    return (
      <ActionAfterViewObserver callback={() => trackMortgageWidgetAnchorShow(verticalName)} callbackDelay={1000}>
        <div className={styles['container']}>
          <a href="#servicePlaceUnderMap" className={styles['anchor-next']} onClick={handleAnchorClick}>
            <div className={styles['anchor-icon']}>
              <IconFinanceMortgage16 color="icon-inverted-default" />
            </div>
            В ипотеку от {formatNumber(minPayment)} ₽/мес
          </a>
        </div>
      </ActionAfterViewObserver>
    );
  }

  return (
    <div className={styles['container']}>
      {/* eslint-disable-next-line react/no-danger */}
      <div dangerouslySetInnerHTML={{ __html: mortgageWidgetMarkup }} />
    </div>
  );
};
